import { render, staticRenderFns } from "./clients-parent-child-master-input.vue?vue&type=template&id=1f39a187&scoped=true&"
import script from "./clients-parent-child-master-input.vue?vue&type=script&lang=js&"
export * from "./clients-parent-child-master-input.vue?vue&type=script&lang=js&"
import style0 from "./clients-parent-child-master-input.vue?vue&type=style&index=0&id=1f39a187&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f39a187",
  null
  
)

export default component.exports